<script setup lang="ts">
import type { ApiHomePageTeamBlock } from '~/types/pages/home';

export interface TeamProps {
  members: ApiHomePageTeamBlock['value']['members'];
}

defineProps<TeamProps>();
</script>

<template>
  <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
    <TeamMember
      v-for="memberId in members"
      :id="memberId"
      :key="memberId"
    />
  </div>
</template>
